<script setup>
/**
 * @description 基础 Banner 轮播项组件
 * @param {number} index - Banner 项索引
 * @param {string} theme - 主题色 (dark | light)
 */

// 1. Imports
import { onMounted, onUnmounted, inject } from 'vue'

// 2. Props
const props = defineProps({
  index: {
    type: Number,
    required: true,
  },
  theme: {
    type: String,
    default: 'dark',
  },
})

// 3. Context from Parent
const bannerContext = inject('baseBannerContext')

// 4. Methods
const handleClick = (e) => {
  if (bannerContext?.clickPrevented.value) {
    e.preventDefault()
    e.stopPropagation()
  }
}

// 5. Lifecycle
onMounted(() => {
  if (bannerContext) {
    bannerContext.registerItem({
      theme: props.theme,
      index: props.index,
    })
  }
})

onUnmounted(() => {
  if (bannerContext) {
    bannerContext.unregisterItem({
      theme: props.theme,
      index: props.index,
    })
  }
})
</script>

<template>
  <div
    class="base-banner-item"
    :data-index="index"
    :class="{ 'base-banner-item--active': bannerContext?.currentIndex.value === index }"
    @click.capture="handleClick"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.base-banner-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 0;
  pointer-events: none;
  transform: translateZ(0);
  backface-visibility: hidden;
  will-change: opacity;

  &--active {
    z-index: 1;
    opacity: 1;
    pointer-events: auto;
  }
}
</style>
